/**
 * Datos para las secciones legales
 * Política de privacidad y Términos y condiciones
 */

import { COMPANY_INFO } from '../constants';

// Secciones de la política de privacidad
export const PRIVACY_SECTIONS = [
  {
    id: "introduction",
    icon: "FaInfoCircle",
    title: "Aviso de Privacidad Simplificado",
    content: `Este Aviso forma parte del uso de nuestros servicios y sitio web. Para ${COMPANY_INFO.legalName}, denominada "La Empresa", es responsable del tratamiento de sus datos personales, con domicilio en ${COMPANY_INFO.address}.`,
    highlight: true
  },
  {
    id: "data-collection",
    icon: "FaDatabase",
    title: "¿Para qué recabamos y utilizamos sus datos?",
    content: "Con la finalidad de poder otorgar un mejor servicio de enfermería especializada y brindar información de los servicios que ofrecemos, requerimos:",
    list: [
      "Nombre(s) y Apellidos del paciente y familiar responsable",
      "Teléfono de contacto principal y de emergencia", 
      "Dirección completa para servicios a domicilio",
      "Correo electrónico para comunicaciones",
      "Datos médicos relevantes (diagnósticos, medicamentos, alergias)",
      "Información sobre necesidades específicas de cuidado",
      "Datos del médico tratante y contactos de emergencia"
    ],
    note: "Para dar un buen servicio requerimos que la información deberá ser veraz y completa en todo momento. El usuario podrá completar los campos para recabar la información solicitada y, en ningún caso 'La Empresa' será responsable de información falsa o incompleta."
  },
  {
    id: "data-usage",
    icon: "FaBullseye",
    title: "Uso de la Información",
    content: "La Empresa utiliza la información obtenida para:",
    list: [
      "Contactar al usuario y proporcionar servicios de enfermería eficientes",
      "Coordinar citas médicas y seguimiento del paciente",
      "Envío de información sobre nuestros servicios y promociones",
      "Comunicación con médicos tratantes y personal de salud autorizado",
      "Facturación y gestión administrativa de los servicios",
      "Mejora continua de nuestros protocolos de atención",
      "Cumplimiento de obligaciones legales del sector salud"
    ]
  },
  {
    id: "ip-analytics",
    icon: "FaEye",
    title: "Información Técnica y Analítica",
    content: "La Empresa utiliza información de la dirección IP para analizar y tener una mejor administración del sitio web. La IP no será utilizada para identificar a los usuarios, siempre y cuando no se esté investigando un caso de posibles actividades fraudulentas o uso indebido de nuestros servicios."
  },
  {
    id: "data-processing",
    icon: "FaSyncAlt",
    title: "Procesamiento de la Información",
    content: "Una vez recibida la información, ésta es procesada para permanecer en nuestra base de datos segura, posteriormente se turna a personal médico especializado para:",
    list: [
      "Evaluar las necesidades específicas del paciente",
      "Asignar al profesional de enfermería más adecuado",
      "Establecer protocolos de atención personalizada",
      "Coordinar con el equipo médico multidisciplinario",
      "Generar reportes de seguimiento médico"
    ]
  },
  {
    id: "security-measures",
    icon: "FaLock",
    title: "Medidas de Seguridad",
    content: "Implementamos las siguientes medidas para proteger sus datos personales:",
    list: [
      "Cifrado de datos en tránsito y en reposo",
      "Acceso restringido solo a personal autorizado",
      "Auditorías periódicas de seguridad",
      "Capacitación continua en protección de datos",
      "Respaldos seguros de información"
    ]
  },
  {
    id: "data-sharing",
    icon: "FaShareAlt",
    title: "Transferencia de Datos",
    content: "Sus datos personales podrán ser compartidos únicamente con:",
    list: [
      "Médicos tratantes y profesionales de salud involucrados",
      "Autoridades sanitarias cuando sea legalmente requerido",
      "Familiares autorizados expresamente por el paciente",
      "Proveedores de servicios esenciales bajo acuerdos de confidencialidad"
    ],
    note: "En ningún caso vendemos o compartimos sus datos con terceros para fines comerciales."
  },
  {
    id: "user-rights",
    icon: "FaUserShield",
    title: "Derechos ARCO",
    content: "Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de sus datos personales. Para ejercer estos derechos, puede contactarnos a:",
    list: [
      `Correo electrónico: ${COMPANY_INFO.email}`,
      `Teléfono: ${COMPANY_INFO.phone}`,
      `Dirección: ${COMPANY_INFO.address}`
    ]
  },
  {
    id: "cookies",
    icon: "FaCookieBite",
    title: "Uso de Cookies y Tecnologías de Rastreo",
    content: "En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, le informamos que este sitio utiliza cookies propias y de terceros, así como píxeles de seguimiento (Google Analytics, Google Ads y Meta/Facebook Pixel), para analizar el comportamiento de navegación, medir el desempeño de nuestras campañas y mostrar contenido relevante. Al ingresar al sitio, un aviso le permite aceptar o rechazar estas cookies antes de que se active cualquier herramienta de analítica o publicidad no esencial.",
    list: [
      "Cookies necesarias: indispensables para el funcionamiento básico del sitio (no requieren consentimiento)",
      "Cookies analíticas (Google Analytics): nos ayudan a entender cómo se usa el sitio de forma agregada",
      "Cookies publicitarias (Google Ads, Meta Pixel): permiten medir y optimizar nuestras campañas",
      "Su elección se guarda en su navegador y puede modificarla borrando los datos de navegación del sitio"
    ],
    note: "Puede configurar su navegador para rechazar cookies, aunque esto podría afectar algunas funcionalidades del sitio."
  },
  {
    id: "changes",
    icon: "FaSyncAlt",
    title: "Cambios al Aviso de Privacidad",
    content: `Nos reservamos el derecho de actualizar este aviso de privacidad. Los cambios serán publicados en nuestro sitio web ${COMPANY_INFO.website}. Le recomendamos revisar periódicamente esta página.`,
    note: `Última actualización: ${COMPANY_INFO.lastPolicyUpdate}`
  },
  {
    id: "contact",
    icon: "FaHeadset",
    title: "Contacto",
    content: "Para cualquier duda o aclaración sobre este aviso de privacidad, puede contactarnos:",
    list: [
      `📧 Email: ${COMPANY_INFO.email}`,
      `📞 Teléfono: ${COMPANY_INFO.phone}`,
      `📍 Dirección: ${COMPANY_INFO.address}`
    ]
  }
];

// Secciones de términos y condiciones
export const TERMS_SECTIONS = [
  {
    id: "introduction",
    icon: "FaInfoCircle",
    title: "1. Introducción",
    content: `Bienvenido a ${COMPANY_INFO.name}. Estos términos y condiciones regulan el uso de nuestros servicios de enfermería especializada en Guadalajara, Jalisco. Al contratar nuestros servicios, usted acepta cumplir con estos términos de manera integral.`,
    highlight: true
  },
  {
    id: "services",
    icon: "FaHandHoldingHeart",
    title: "2. Servicios Ofrecidos",
    content: `${COMPANY_INFO.name} ofrece servicios de enfermería especializada, incluyendo:`,
    list: [
      "Atención domiciliaria para adultos mayores",
      "Cuidados postoperatorios especializados",
      "Administración de medicamentos",
      "Monitoreo de signos vitales",
      "Acompañamiento y apoyo emocional",
      "Servicios de rehabilitación básica"
    ]
  },
  {
    id: "user-obligations",
    icon: "FaUserCheck",
    title: "3. Obligaciones del Cliente",
    content: "Para garantizar la calidad del servicio, el cliente se compromete a:",
    list: [
      "Proporcionar información veraz y completa sobre el estado de salud del paciente",
      "Respetar los horarios y condiciones establecidas en el contrato de servicio",
      "Cumplir con los pagos acordados en los tiempos y formas establecidos",
      "Facilitar un ambiente seguro y adecuado para la prestación del servicio",
      "Comunicar oportunamente cualquier cambio en las condiciones del paciente"
    ]
  },
  {
    id: "payments",
    icon: "FaMoneyBillWave",
    title: "4. Términos de Pago y Reembolsos",
    content: "Las condiciones económicas se rigen por las siguientes políticas:",
    list: [
      "Los pagos deben realizarse puntualmente en la fecha acordada",
      "Se aceptan pagos en efectivo, transferencia bancaria o depósito",
      "No se realizan reembolsos una vez iniciado el servicio contratado",
      "En caso de cancelación anticipada, se aplicará una penalización del 20%",
      "Los precios pueden ajustarse con previo aviso de 30 días"
    ]
  },
  {
    id: "responsibility",
    icon: "FaExclamationTriangle",
    title: "5. Limitación de Responsabilidad",
    content: `${COMPANY_INFO.name} se compromete a brindar servicios profesionales de la más alta calidad. Sin embargo, nuestra responsabilidad se limita a:`,
    list: [
      "Los servicios específicamente contratados y documentados",
      "El cumplimiento de protocolos médicos estándar",
      "La confidencialidad de la información del paciente"
    ],
    note: "No nos hacemos responsables por condiciones preexistentes del paciente, complicaciones médicas imprevistas, o decisiones médicas que excedan nuestro ámbito de competencia."
  },
  {
    id: "modifications",
    icon: "FaEdit",
    title: "6. Modificaciones de Términos",
    content: "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios se notificarán mediante:",
    list: [
      "Publicación en nuestro sitio web oficial",
      "Notificación directa a clientes activos",
      "Comunicación por correo electrónico",
      "Aviso con al menos 15 días de anticipación"
    ]
  },
  {
    id: "cancellation",
    icon: "FaFileContract",
    title: "7. Política de Cancelación",
    content: "Las cancelaciones de servicio se rigen por las siguientes condiciones:",
    list: [
      "Cancelación con 48 horas de anticipación: sin cargo",
      "Cancelación con 24 horas de anticipación: 10% del servicio",
      "Cancelación el mismo día: 25% del servicio",
      "No presentarse sin aviso: 50% del servicio contratado"
    ]
  },
  {
    id: "contact",
    icon: "FaHeadset",
    title: "8. Contacto",
    content: "Para cualquier duda o aclaración sobre estos términos, puede contactarnos:",
    list: [
      `📧 Email: ${COMPANY_INFO.email}`,
      `📞 Teléfono: ${COMPANY_INFO.phone}`,
      `📍 Dirección: ${COMPANY_INFO.address}`
    ]
  }
];
